import nav from '@/containers/_nav';

let checkUIPermissions = function checkSidebarNavPermissions() {
    var navProps = Object.assign([], nav);
    var permissions = JSON.parse(localStorage.getItem('permissions'));
    var isUserLoggedIn = localStorage.getItem('apiToken') ? true : false

    if (!permissions)
        return;

    if (navProps.length > 0) {
        var navbarItems = [];

        navProps[0]._children.forEach(function (navItem) {

            if (navItem.name === "Home" && isUserLoggedIn) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Portfolio" && isUserLoggedIn) {
                navbarItems.push(navItem);

                if (navItem.items) {
                    var navbarChildItems = [];

                    navItem.items.forEach(function (navItem) {
                        if (navItem.name === "MyPortfolio") { //No exact permission for this one
                            navbarChildItems.push(navItem);
                        }
                        if (navItem.name === "MyClients" && permissions["Permissions.Client.View"]) {
                            navbarChildItems.push(navItem);
                        }
                        if (navItem.name === "MyTrades" && permissions["Permissions.Trades.View"]) {
                            navbarChildItems.push(navItem);
                        }
                        if (navItem.name === "MyTriggers" && permissions["Permissions.Triggers.View"]) {
                            navbarChildItems.push(navItem);
                        }
                        if (navItem.name === "MyAlerts" && permissions["Permissions.Alerts.View"]) {
                            navbarChildItems.push(navItem);
                        }
                    });
                    navItem.items = navbarChildItems;
                }
            }
            if (navItem.name === "Alerts" && permissions["Permissions.Alerts.View"]) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Clients" && permissions["Permissions.Client.View"]) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Companies" && permissions["Permissions.Client.View"]) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Contracts" && permissions["Permissions.Contract.View"]) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Trading Groups" && permissions["Permissions.TradingGroup.View"]) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Trades" && permissions["Permissions.Trades.View"]) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Uploads" && permissions["Permissions.UploadTemplate.View"]) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Reports" && permissions["Permissions.Reports.View"]) {
                let childItems = [];
                navItem.items.forEach(function (item) {
                    if (item.name == "AdminReports") {
                        if (permissions["Permissions.AdminReports.View"]) {
                            childItems.push(item);
                        }
                    }
                    else { childItems.push(item); }
                });
                navItem.items = childItems;
                if (childItems.length > 0) {
                    navbarItems.push(navItem);
                }
            }
            if (navItem.name === "Triggers" && permissions["Permissions.Triggers.View"]) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Markets" && (permissions["Permissions.LatestSettlement.View"])) {
                navbarItems.push(navItem);
            }
            if (navItem.name === "SecureVersion") {
                navbarItems.push(navItem);
            }
            if (navItem.name === "Administration" && isUserLoggedIn) {
                let childItems = [];
                navItem.items.forEach(function (item) {
                    if (item.name == "Users & Permissions" &&
                        (permissions["Permissions.Users.View"])) {
                        childItems.push(item);

                    } else if (item.name == "Product Specifications" &&
                        (permissions["Permissions.Product.View"] ||
                            permissions["Permissions.TradePeriod.View"] ||
                            permissions["Permissions.SpotExchanges.View"] ||
                            permissions["Permissions.FutureExchanges.View"] ||
                            permissions["Permissions.Ric.View"] ||
                            permissions["Permissions.RicOtherInstruments.View"] ||
                            permissions["Permissions.CurrencyConversion.View"] ||
                            permissions["Permissions.MarketShape.View"])) {
                        childItems.push(item);

                    } else if (item.name == "General" &&
                        (permissions["Permissions.Currencies.View"] ||
                            permissions["Permissions.State.View"] ||
                            permissions["Permissions.Suppliers.View"] ||
                            permissions["Permissions.DefaultMechanisms.View"] ||
                            permissions["Permissions.ReferenceTypes.View"] ||
                            permissions["Permissions.Sectors.View"] ||
                            permissions["Permissions.StrategyTypes.View"])) {
                        childItems.push(item);

                    } else if (item.name == "Contract Management" &&
                        (permissions["Permissions.Offices.View"] ||
                            permissions["Permissions.ClientCoordinator.View"] ||
                            permissions["Permissions.Consultants.View"] ||
                            permissions["Permissions.RiskManager.View"])) {
                        childItems.push(item);
                    } else if (item.name == "Units" &&
                        (permissions["Permissions.Offices.View"] ||
                            permissions["Permissions.TradingUnits.View"] ||
                            permissions["Permissions.VolumeUnits.View"])) {
                        childItems.push(item);
                    }
                })
                navItem.items = childItems;
                if (childItems.length > 0) {
                    navbarItems.push(navItem);
                }
            }
        });
        navProps[0]._children = navbarItems;
    }
}

export default checkUIPermissions;